import { optimizedAppearDataAttribute } from './data-id.mjs';

function getOptimisedAppearId(visualElement) {
    return visualElement.getProps()[optimizedAppearDataAttribute];
}

export { getOptimisedAppearId };
